import React from "react";
import PageHero from "./PageHero";

const Skincare = () => {
  return (
    <div>
      <PageHero />
    </div>
  );
};

export default Skincare;
